"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Provider_1 = require("../../components/Provider");
// O: the original props without context property
// C: Stuff delivered by the context
// W: Interface containing the prop which gets spreaded on the component
/**
 * This is a higher order function which provides the context `Context` to the component `Component`
 * as prop `contextPropName`. The returned information will show up as `displayName`.
 * The convention is to name the wrapped component like the outer component with the suffix `WithinContext` -
 * `Abc` becomes `AbcWithinContext`.
 * @param displayName The name of the returned component
 * @param Context The context to consume (result of `React.createContext(...)`)
 * @param contextPropName The name of the prop the value of the context is set to
 * @param Component The component which gets wrapped (should be `${displayName}WithinContext`)
 */
function withContext(displayName, Context, contextPropName, Component) {
    var _a;
    var propTypes = __assign({}, Component.propTypes);
    delete propTypes[contextPropName];
    var defaultProps = __assign({}, Component.defaultProps);
    delete defaultProps[contextPropName];
    var ContextifiedComponent = (_a = /** @class */ (function (_super) {
            __extends(class_1, _super);
            function class_1() {
                var _this = _super !== null && _super.apply(this, arguments) || this;
                _this.displayName = displayName;
                return _this;
            }
            class_1.prototype.render = function () {
                var _this = this;
                return (React.createElement(Context.Consumer, null, function (context) {
                    var _a;
                    var componentProps = __assign((_a = {}, _a[contextPropName] = context, _a), _this.props);
                    return React.createElement(Component, __assign({}, componentProps));
                }));
            };
            return class_1;
        }(React.Component)),
        _a.propTypes = propTypes,
        _a.defaultProps = defaultProps,
        _a);
    // returns `undefined`, if the property does not exist
    var propertyDescriptor = Object.getOwnPropertyDescriptor(ContextifiedComponent, 'name');
    // We can define the property if (1) the object is not sealed and (2.1) the object
    // does not have the property yet or (2.2) the property is configurable.
    if (!Object.isSealed(ContextifiedComponent) && (!propertyDescriptor || propertyDescriptor.configurable)) {
        Object.defineProperty(ContextifiedComponent, 'name', {
            value: displayName,
            writable: true
        });
    }
    return ContextifiedComponent;
}
exports.withContext = withContext;
/**
 * Wraps a component and provides the context of the `Provider` component as prop `ergoElements`.
 * @param displayName The name of the returned component
 * @param component The component to wrap. Should be called `${displayName}WithinContext`
 */
function withErgoElementsContext(displayName, component) {
    return withContext(displayName, Provider_1.ErgoElementsContext, 'ergoElements', component);
}
exports.withErgoElementsContext = withErgoElementsContext;
//# sourceMappingURL=withContext.js.map